import type { SeasonalSceneKind } from "@/domain/seasonal"
import type { ComponentType } from "react"
import { HalloweenNightScene, type SeasonalSceneProps } from "./HalloweenNightScene"

export type { ScenePhase, SeasonalSceneProps } from "./HalloweenNightScene"

/** Scene component of each seasonal scene kind. */
export const SEASONAL_SCENES: Record<SeasonalSceneKind, ComponentType<SeasonalSceneProps>> = {
  halloweenNight: HalloweenNightScene,
}
